export default {
  AuthProvider__LOGIN_SUCCESSFUL_ARIA: "Login successful",
  AuthProvider__LOGOUT_SUCCESSFUL_ARIA: "Logout successful",
};
